export const snakeToCamelConverter = (string) => string.replace(/_./g, (x) => x.toUpperCase()[1]);
//# sourceMappingURL=snakeToCamel.js.map